import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/shared/context/AuthContext';
import { Box, CircularProgress } from '@mui/material';

interface OrgAppRouteProps {
  children: React.ReactNode;
}

const OrgAppRoute: React.FC<OrgAppRouteProps> = ({ children }) => {
  const { isAuthenticated, loading, user } = useAuth();

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (user?.role === 'super_admin') {
    return <Navigate to="/platform" replace />;
  }

  return <>{children}</>;
};

export default OrgAppRoute;
